export interface IShaImageProps {
  source: {
    uri: string;
    height?: any;
    width?: any;
  };
  style?: any;
}

export interface IShaImageSliderProps {
  images: any[];
  containerStyle: any;
}
